import { safeApiRequest } from './apiClient';

/**
 * Teknik servisleri bakiye ile listele
 */
export const fetchTeknikServisler = async ({ arama, sayfa = 1, limit = 50 } = {}) => {
  const query = { sayfa, limit };
  if (arama && arama.trim()) query.arama = arama.trim();

  const response = await safeApiRequest('/api/cari/v2/teknik-servisler', {
    method: 'GET',
    query,
    skipCsrf: true,
  });
  return response;
};

/**
 * Teknik servis cari hareketleri
 */
export const fetchCariHareketler = async (
  teknikServisId,
  { sayfa = 1, limit = 50, baslangicTarihi, bitisTarihi } = {},
) => {
  const query = { sayfa, limit };
  if (baslangicTarihi) query.baslangicTarihi = baslangicTarihi;
  if (bitisTarihi) query.bitisTarihi = bitisTarihi;
  const response = await safeApiRequest(`/api/cari/v2/teknik-servisler/${teknikServisId}/hareketler`, {
    method: 'GET',
    query,
    skipCsrf: true,
  });
  return response;
};

/**
 * Teknik servis bakiyesi
 */
export const fetchCariBakiye = async (teknikServisId) => {
  const response = await safeApiRequest(`/api/cari/v2/teknik-servisler/${teknikServisId}/bakiye`, {
    method: 'GET',
    skipCsrf: true,
  });
  return response;
};

/**
 * Ödeme ekle (Admin -, Tech +)
 */
export const cariOdemeEkle = async (teknikServisId, { odemeYontemi, odemeNotu, tutar }) => {
  const response = await safeApiRequest(`/api/cari/v2/teknik-servisler/${teknikServisId}/odeme`, {
    method: 'POST',
    body: { odemeYontemi, odemeNotu, tutar },
  });
  return response;
};

/**
 * Tahsilat ekle (Admin +, Tech -)
 */
export const cariTahsilatEkle = async (teknikServisId, { odemeYontemi, odemeNotu, tutar }) => {
  const response = await safeApiRequest(`/api/cari/v2/teknik-servisler/${teknikServisId}/tahsilat`, {
    method: 'POST',
    body: { odemeYontemi, odemeNotu, tutar },
  });
  return response;
};

/**
 * Hareket iptal et
 */
export const cariHareketIptal = async (hareketId) => {
  const response = await safeApiRequest(`/api/cari/v2/hareketler/${hareketId}/iptal`, {
    method: 'PATCH',
  });
  return response;
};
